;(function($, window) {
    'use strict';
    $.plugin('l04elasticsearch', {
        defaults: {
            'triggerElSelector': '#ElasticSearchForm',
            'language':'/de',
            'requestFile':'',
            'resultCount':0,
            'entriesPerPage':8,
            'order':'desc',
            'path':'/',
            'category':'',
            'requestTarget':'.searchResults'
        },
        init: function () {
            var me = this;
            me.opts = $.extend(true, {}, me.opts, me.$el.data());
            me.initSearch(me.$el,me.opts);
        },
        initSearch: function($form,opts){
            var me = this;
            opts.url = opts.requestFile;
            opts.$requestTarget = $form.find(opts.requestTarget);
            opts.loadMoreButton = $form.find('#searchLoaderBtn');
            opts.loadMoreButton.click(function(e){
                e.preventDefault();
                e.stopPropagation();
                // the new breadcrumb over the search item doubled the total result count
                opts.currentOffset = opts.$requestTarget.children().length / 2;
                me.onFetch(opts,me.afterFetch);
            });
        },
        onFetch: function (opts, callback){
            var data = {
                language: opts.language,
                path: opts.path,
                category: opts.category,
                order: opts.order,
                search: opts.search,
                offset: opts.currentOffset,
                limit: opts.entriesPerPage
            };
            data = $.extend(true, {}, data, opts.filter);
            var request = {
                type: 'GET',
                url: opts.url,
                dataType: 'html',
                data: data,
                opts: opts
            };
            window.ContentFetcher.fetch(request, callback);
        },
        afterFetch: function (data){/*apply data here*/
            var request = this;
            /*apply data here*/
            if (!data) {
                return;
            }

            if( data.includes("\"noResultsText\"") ){
                $("#searchLoaderBtn").remove();
            }

            var opts = request.opts;
            var htmlString = data;

            //append results
            if(htmlString.length > 0){
                var $htmlObject = $(htmlString);
                opts.$requestTarget.append($htmlObject);
            }
            $.publish('plugin/search/afterFetch', opts.$requestTarget);
        },
        destroy: function () {
            var me = this;
            me._destroy();
        }
    });
})(jQuery, window);
